import { render, staticRenderFns } from "./liquidaciones.vue?vue&type=template&id=ed511a04&scoped=true"
import script from "./liquidaciones.vue?vue&type=script&lang=js"
export * from "./liquidaciones.vue?vue&type=script&lang=js"
import style0 from "./liquidaciones.vue?vue&type=style&index=0&id=ed511a04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed511a04",
  null
  
)

export default component.exports